exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".close-alert[data-v-982f321a]{color:#806829;background-color:#fdf3d1;margin-bottom:10px}.close-alert-red[data-v-982f321a]{color:red;font-weight:700;width:2.3em;font-size:15px}", ""]);

// exports
